import { ChainId } from "../config/chain";
import { config } from "../config/config";

interface GetNoteFunUrlParams {
  token: string;
  chainId: ChainId;
}

export const getNoteFunUrl = ({ token, chainId }: GetNoteFunUrlParams) => {
  return `${config.noteFunUrl}/solana/${token}${
    chainId === ChainId.SOLANA_DEVNET ? "?cluster=devnet" : ""
  }`;
};
